import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { APP_INFO } from "../../config/appConfig";
import { getRouteDocumentLabel } from "../navigation";

const TITLE_SEPARATOR = " · ";

const RouteTitleSync = () => {
    const location = useLocation();

    useEffect(() => {
        const pageLabel = getRouteDocumentLabel(location.pathname, location.search);
        document.title = pageLabel ? `${pageLabel}${TITLE_SEPARATOR}${APP_INFO.FULL_NAME}` : APP_INFO.FULL_NAME;
    }, [location.pathname, location.search]);

    return null;
};

export default RouteTitleSync;
